<template>
  <div>
    <div class="banner-sec">
      <div class="banner banner-imp-eng">
        <div class="wd1">
          <h2 class="banner-title-main">服务特色</h2>
        </div>
      </div>
    </div>
    <div class="cp-one-2">
      <div class="wd clearfix">
        <div class="cp-img-wrap"><img src="../assets/images/product3.png" class="cp-img"></div>
        <div class="cp-one-right">
          <div class="right-style">
            <h2>合法合规</h2>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;来源清晰且合规</p>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;确保不留存数据</p>
            <h2>产品丰富</h2>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;多种数据产品可供选择</p>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;不断新增数据产品</p>
            <h2>服务贴心</h2>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;建立客户专属沟通群, 随时解答疑问、提供服务</p>
            <!--<h2>快速对接</h2>-->
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;提供API对接以及网页版查询</p>
            <p class="cp-desc"><i class="fa fa-circle-o"></i> &nbsp;&nbsp;技术文档清晰, 有专人负责配合完成
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Home',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Product.vue